export default __webpack_public_path__ + "media/images/theme_apple/loading-6bf54391dc88fbbac30d1b6b8f315cb4.gif";